// extracted by mini-css-extract-plugin
export var orderDetails = "_qy-2";
export var orderImage = "_qy-1";
export var orderMeta = "_qy-3";
export var orderSummary = "_qy-0";
export var rightArrow = "_qy-4";